module.exports = __webpack_public_path__ + "static/media/duke.7aaf83cb.webp";